import { PREFIX } from '../../shared/utils/index.ts';

export function getLoader(loader: 'background' | 'foreground') {
  return `var(${PREFIX.LOADER}${loader})`;
}
